import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class Atol7PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.ATOL7;
}

export default Atol7PoiTileEntity;
